import { DataSource } from '@angular/cdk/table';
import { Component, Input, OnInit } from '@angular/core';
import { OrganisationInterface } from '@careapp/angular-sdk';
import { Observable } from 'rxjs';

@Component({
  selector: 'organisations-table',
  templateUrl: './organisations-table.component.html'
})
export class OrganisationsTableComponent implements OnInit {
  @Input() organisations: Observable<Array<OrganisationInterface>>;

  dataSource: OrganisationDataSource;
  displayedColumns: Array<string>;

  ngOnInit() {
    this.displayedColumns = ['name', 'number', 'address'];
    this.dataSource = new OrganisationDataSource(this.organisations);
  }
}

export class OrganisationDataSource extends DataSource<any> {
  constructor(public data: Observable<Array<OrganisationInterface>>) {
    super();
  }

  connect(): Observable<Array<OrganisationInterface>> {
    return this.data;
  }

  disconnect() {
    // lint
  }
}
